var video_viewer_default = {
  "video_player": "LoD3Z",
  "videoOverlay": "g471b",
  "video_container": "Q-I40"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
